import { render, staticRenderFns } from "./PerguntasPizza.vue?vue&type=template&id=a2cfd71a&scoped=true&"
import script from "./PerguntasPizza.vue?vue&type=script&lang=js&"
export * from "./PerguntasPizza.vue?vue&type=script&lang=js&"
import style0 from "./PerguntasPizza.vue?vue&type=style&index=0&id=a2cfd71a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2cfd71a",
  null
  
)

export default component.exports